import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get(`data-for-course-session-create`)
}
